<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PurchaseProjectStatusBadge from 'dashboard/components-next/Contacts/PurchaseProjects/PurchaseProjectStatusBadge.vue';

const props = defineProps({
  member: {
    type: Object,
    required: true,
  },
  projects: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['openProject']);

const { t, locale } = useI18n();

const linkedProjects = computed(() =>
  props.projects.filter(
    project =>
      project.beneficiaryType === 'close_circle_member' &&
      String(project.beneficiaryId) === String(props.member.id)
  )
);

const formatDate = value => {
  if (!value) return '';
  return new Intl.DateTimeFormat(locale.value, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(value));
};
</script>

<template>
  <section class="flex flex-col bg-n-solid-1">
    <div class="flex items-center justify-between px-4 py-3">
      <h3 class="text-sm font-semibold text-n-slate-12">
        {{ t('CLOSE_CIRCLE.DETAIL.LINKED_PROJECTS') }}
      </h3>
      <span class="text-xs text-n-slate-10">
        {{ linkedProjects.length }}
      </span>
    </div>

    <div v-if="linkedProjects.length" class="flex flex-col">
      <template v-for="(project, index) in linkedProjects" :key="project.id">
        <div v-if="index > 0" class="mx-4 h-px bg-n-weak" />
        <button
          type="button"
          class="group flex w-full flex-col gap-1 px-4 py-3 text-left transition-colors hover:bg-n-alpha-1"
          @click="emit('openProject', { project, member })"
        >
          <div class="flex items-start justify-between gap-2">
            <p class="min-w-0 truncate text-sm font-medium text-n-slate-12">
              {{ project.title }}
            </p>
            <PurchaseProjectStatusBadge
              :status="project.status"
              class="shrink-0"
            />
          </div>
          <p class="text-xs text-n-slate-10">
            <span v-if="project.dueDate">{{
              formatDate(project.dueDate)
            }}</span>
            <span v-if="project.occasion">
              <span v-if="project.dueDate"> · </span>
              {{
                t(
                  `PURCHASE_PROJECTS.OCCASIONS.${project.occasion.toUpperCase()}`
                )
              }}
            </span>
          </p>
        </button>
      </template>
    </div>

    <p v-else class="px-4 pb-4 text-sm text-n-slate-11">
      {{ t('CLOSE_CIRCLE.DETAIL.NO_LINKED_PROJECTS') }}
    </p>
  </section>
</template>
